import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "simple",
  "title": "About",
  "lead": ""
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h2: "h2",
    hr: "hr",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {Aside, FederalMinistryGermanyLogo, LinkBlock, Title} = _components;
  if (!Aside) _missingMdxReference("Aside", true);
  if (!FederalMinistryGermanyLogo) _missingMdxReference("FederalMinistryGermanyLogo", true);
  if (!LinkBlock) _missingMdxReference("LinkBlock", true);
  if (!Title) _missingMdxReference("Title", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Title, {
      padded: true,
      children: "About"
    }), "\n", _jsx(_components.h2, {
      id: "about-scope",
      children: "About SCOPE"
    }), "\n", _jsx(_components.p, {
      children: "Scoping Progress in Education (SCOPE) brings together administrative data, household surveys, learning assessments and education finance from various data producers, notably the UNESCO Institute for Statistics, to explore the progress made towards SDG 4, the global education goal."
    }), "\n", _jsxs(_components.p, {
      children: ["It complements the ", _jsx(_components.a, {
        href: "https://en.unesco.org/gem-report/allreports",
        children: "printed edition"
      }), " of the Global Education Monitoring Report, enabling users to interact with the data to understand the achievements and challenges of countries and regions as they aim to reach the targets. Shareable and downloadable, users can create images and data files to explore further, print, or use online or in presentations."]
    }), "\n", _jsx(_components.h2, {
      id: "about-the-global-education-monitoring-report",
      children: "About the Global Education Monitoring Report"
    }), "\n", _jsxs(_components.p, {
      children: ["The Global Education Monitoring Report is an editorially independent annual report hosted and published by UNESCO. According to the ", _jsx(_components.a, {
        href: "https://unesdoc.unesco.org/ark:/48223/pf0000245656",
        children: "Education 2030 Framework for Action"
      }), ", it has the mandate to monitor progress on education in the SDGs and on the implementation of national and international education strategies to help hold all relevant partners to account for their commitments."]
    }), "\n", _jsx(LinkBlock, {
      title: "Visit the website",
      url: "https://en.unesco.org/gem-report/",
      variant: "gem"
    }), "\n", _jsx(_components.h2, {
      id: "about-sustainable-development-goal-4",
      children: "About Sustainable Development Goal 4"
    }), "\n", _jsxs(_components.p, {
      children: ["In September 2015, at the United Nations Sustainable Development Summit in New York, Member States formally adopted the ", _jsx(_components.a, {
        href: "https://sustainabledevelopment.un.org/post2015/transformingourworld",
        children: "2030 Agenda for Sustainable Development"
      }), ". The agenda contains 17 goals, one of which, SDG 4, is to ‘ensure inclusive and equitable quality education and promote lifelong learning opportunities for all’. SDG 4 has seven targets and three means of implementation."]
    }), "\n", _jsx(LinkBlock, {
      title: "View the targets and associated monitoring frameworks",
      url: "https://sustainabledevelopment.un.org/sdg4",
      variant: "sdg4"
    }), "\n", _jsx(FederalMinistryGermanyLogo, {
      lang: "en"
    }), "\n", _jsx(_components.p, {
      children: "Special thanks go to the German Federal Ministry of Education and Research for its partnership and generous contribution to develop the Education Progress website."
    }), "\n", _jsxs(Aside, {
      children: [_jsx(_components.h2, {
        id: "contact",
        children: "Contact"
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "General Email"
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "mailto:gemreport@unesco.org",
          children: "gemreport@unesco.org"
        })
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "The Team"
      }), _jsx(_components.p, {
        children: "GEM Report Team, UNESCO"
      }), _jsx(_components.hr, {}), _jsx(_components.p, {
        children: "Our Address"
      }), _jsx(_components.p, {
        children: "Global Education Monitoring Report Team (GEM Report),\nUNESCO, 7 place de Fontenoy, 75352 Paris 07 SP, France"
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
